import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header";

const getAddress = (id) => {
  return axios.get(API + "parties/manage-address/" + id + "/", {
    headers: authHeader(),
  });
};

const addContract = (
  contract_number,
  description,
  customer_id,
  start_date,
  contract_term,
  address_id,
  contract_type,
  end_date,
  deposit_amount,
  feesontime,
  tax_rate_rent,
  tax_rate_fee,
  paymentrule,
  extrafiledcontract,
  paymentstartdate,
  amount,
  frequency,
  payment_type,
  achPayments,
  achAccount,
  appOriginator,
  source,
  salesRep,
  subcompany,
  line_of_business,
  contractTerms   

) => {
  return axios.post(
    API + "contracts/create-contract/",
    {
      contract_number,
      description,
      customer_id,
      start_date,
      contract_term,
      address_id,
      contract_type,
      end_date,
      deposit_amount,
      feesontime,
      tax_rate_rent,
      tax_rate_fee,
      paymentrule,
      extrafiledcontract,
      paymentstartdate,
      amount,
      frequency,
      payment_type,
      enable_ach: achPayments ? 'Y' : 'N',
      ach_account_id: achAccount || null,
      appOriginator,
      source,
      salesRep,
      subcompany,
      line_of_business,
      termsCondition: contractTerms,   
    },
    { headers: authHeader() }
  );
};
const AddContractService = {
  addContract,
  getAddress,
};
export default AddContractService;
